/** Shared packaging-list column ordering from the reviewed Figma frames. */
export const packagingListLayoutTokens = {
    leadingColumnOrder: ["name", "externalId", "type"],
} as const;
